import * as types from "./mutation-types";
import * as EnrollmentService from "../../../services/visualization/recruitment";
import * as dataManagementService from "../../../services/visualization/data-management";
import _isEmpty from "lodash/isEmpty";
import * as commonHelper from "@/components/services/common-helper";
import * as utils from "../../../services/visualization/utils";

const resetParticipantFocusDashboard = async (dispatch, commit) => {
  await dispatch("saveOverallCollectionData", {});
  await dispatch("saveOverallCollectionParticipantData", {});
  commit(types.SET_ECONSET_DISPOSITION_DATA, null);
  commit(types.SET_CONSENT_BLOCKS, null);
  commit(types.SET_COMPLETION, null);
  commit(types.SET_COMPLETION_PARTICIPANT, null);
  commit(types.SET_FILTER_FROM_DATE, '');
  commit(types.SET_FILTER_TO_DATE, '');

  // clear selection of country and site filters
  commit(types.SET_COUNTRY_SELECTED, ["all"]);
  commit(types.SET_SITES_SELECTED, ["all"]);
}

const getSiteId = () => {
  return localStorage.getItem("selectedSite");
}
const isSiteRole = (getters) => {
  return commonHelper.isSiteUser(getters.user.userRole);
}
const checkCurrentSiteOrStudy = async (state, getters) => {
  const _isSiteRole = isSiteRole(getters);
  return getters.studyIdValue === state.currentStudyId && (!_isSiteRole || (_isSiteRole && getSiteId() === state.selectedSiteId));
}

const convertArrToString = arrObj => {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
};

export const getCompletionData = async ({ commit, state, getters, dispatch }, { $api, shouldChangeSelectedFilterOptions = true }) => {
  let response = null;
  const params = {
    studyId: state.currentStudyId
  };

  if (state.participantsSelected && state.participantsSelected[0] !== "all") {
    params.participantsIds = convertArrToString(state.participantsSelected);
    if (params.participantsIds.length === 0) { 
      if (shouldChangeSelectedFilterOptions) { 
        commit (types.SET_COUNTRY_SELECTED, [])
        commit (types.SET_SITES_SELECTED, []) 
      }
      return;
    }
  }

  if (state.fromDate && state.fromDate !== "") {
    params.fromDate = state.fromDate;
    params.toDate = state.toDate;
  }

  if (state.specificSiteId && state.specificSiteId.length) {
    params.siteId = state.specificSiteId[0];
  }

  const _checkCurrentSiteOrStudy = await checkCurrentSiteOrStudy(state, getters)
  if (!state.ignoreCache && getters.overallCollectionData && getters.overallCollectionData.body && _checkCurrentSiteOrStudy) {
    const result = getters.overallCollectionData.body;
    if (result.data && "activities" in result.data) {
      response = result.data.activities;
    }
    commit(types.SET_COMPLETION, response);
    return
  }

  const data = await $api.getOverallColectionEndpoint(params);
  if (data.ok) {
    dispatch("saveOverallCollectionData", data);
    const result = data.body;

    if (!_isEmpty(result.data)) {
      if ("activities" in result.data) {
        response = result.data.activities;

        const countries = dataManagementService.getCountriesByActivities(response);
        const sites = dataManagementService.getSiteByActivities(response, countries);

        const countryList = Array.from(new Set([...state.countryList, ...countries]))
        const allSitesList = Array.from(new Set([...state.allSitesList, ...sites]))

        if (shouldChangeSelectedFilterOptions) {
          commit(types.SET_COUNTRIES, countryList)
          commit(types.SET_SITES, allSitesList)
          commit (types.SET_COUNTRY_SELECTED, countryList)
          commit (types.SET_SITES_SELECTED, allSitesList)
        }
      }
    }
  } 

  commit(types.SET_COMPLETION, response);

}

export const getCompletionParticipantData = async ({ commit, state, getters, dispatch }, { $api, shouldChangeSelectedFilterOptions = true }) => {
  let response = null;
  const params = {
    studyId: state.currentStudyId
  };
  
  if (state.participantsSelected && state.participantsSelected[0] !== "all") {
    params.participantsIds = convertArrToString(state.participantsSelected);
    if (params.participantsIds.length === 0) { 
      if (shouldChangeSelectedFilterOptions) {
        commit (types.SET_COUNTRY_SELECTED, [])
        commit (types.SET_SITES_SELECTED, []) 
      }
      return;
    }
  }

  if (state.fromDate && state.fromDate !== "") {
    params.fromDate = state.fromDate;
    params.toDate = state.toDate;
  }

  if (state.specificSiteId && state.specificSiteId.length) {
    params.siteId = state.specificSiteId[0];
  }

  const _checkCurrentSiteOrStudy = await checkCurrentSiteOrStudy(state, getters)
  if (!state.ignoreCache && getters.overallCollectionParticipantData && getters.overallCollectionParticipantData.body && _checkCurrentSiteOrStudy) {
    const result = getters.overallCollectionParticipantData.body;
    if (result.data && "locations" in result.data) {
      response = result.data.locations;
    }
    commit(types.SET_COMPLETION_PARTICIPANT, response);
    return;
  }
 
  const data = await $api.getOverallColectionParticipantEndpoint(params);
  if (data.ok) {
    const result = data.body;
    dispatch("saveOverallCollectionParticipantData", data);
    if (!_isEmpty(result.data)) {
      if ("locations" in result.data) {
        response = result.data.locations;

        const countries = dataManagementService.getCountries(response);
        const sites = dataManagementService.getSites(response, countries);

        const countryList = Array.from(new Set([...state.countryList, ...countries]))
        const allSitesList = Array.from(new Set([...state.allSitesList, ...sites]))
    
        if (shouldChangeSelectedFilterOptions) {
          commit(types.SET_COUNTRIES, countryList)
          commit(types.SET_SITES, allSitesList)
          commit (types.SET_COUNTRY_SELECTED, countryList)
          commit (types.SET_SITES_SELECTED, allSitesList)
        }
      } 
    }
  } 

  commit(types.SET_COMPLETION_PARTICIPANT, response);
}

export const getVisConsentDispositionRawData = async ({ commit, state, getters, dispatch }, $api) => {
  const body = {};
  let response = null;
  const params = {
    studyId: state.currentStudyId
  };

  if (state.fromDate && state.fromDate !== "") {
    body.fromDate = state.fromDate;
    body.toDate = state.toDate;
  }

  const participantsIds = convertArrToString(state.participantsSelected);
  if (participantsIds.length !== 0 && participantsIds !== "all") {
    body.participantsIds = participantsIds;
  }

  if (Array.isArray(state.specificSiteId) && state.specificSiteId.length > 0) {
    body.siteId = state.specificSiteId[0];
  }

  const _checkCurrentSiteOrStudy = await checkCurrentSiteOrStudy(state, getters)
  if (!state.ignoreCache && getters.eConsentUploadedData && getters.eConsentUploadedData.body && _checkCurrentSiteOrStudy) {
    let responseBody = getters.eConsentUploadedData.body;
    if(responseBody.data){
      response = responseBody.data;
      setVisConsentDispositionRawData(state, commit, response);
      return;
    }
  }

  if (participantsIds.length === 0) {
    setVisConsentDispositionRawData(state, commit, null);
    return;
  }

  const responseData = await $api.getConsentDispositionVisData(params, body)
  if (responseData.ok) {
    const { data } = responseData.body;
    setVisConsentDispositionRawData(state, commit, data)
  }
}

const setEConsentDispositionDataAndConsentBlocks = async (data, state, commit) => {
  const eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(data, state.countrySelected[0] === 'all' ? state.countryList : state.countrySelected, state.sitesSelected[0] === 'all' ? state.allSitesList : state.sitesSelected);
  const consentBlocks = eConsentDispositionData.consentBlocks;
  commit(types.SET_ECONSET_DISPOSITION_DATA, eConsentDispositionData);
  commit(types.SET_CONSENT_BLOCKS, consentBlocks);
}

const setVisConsentDispositionRawData = async (state, commit, response) => {
  commit(types.SET_ECONSENT_RAW_DATA, response);
  if (response === null) {
    commit(types.SET_ECONSET_DISPOSITION_DATA, null);
    commit(types.SET_CONSENT_BLOCKS, null);
    return;      
  }
  await setEConsentDispositionDataAndConsentBlocks(response, state, commit);
}

export const loadParticipantFocusDashboard = async ({commit, dispatch, state}, $api) => {
  await resetParticipantFocusDashboard(dispatch, commit, state);

  await Promise.all([
    dispatch("getCompletionData", { $api }),
    dispatch("getCompletionParticipantData", { $api }),
    dispatch("getVisConsentDispositionRawData", $api)
  ])
  if (!_isEmpty(state.eConsentRawData)) {
    await setEConsentDispositionDataAndConsentBlocks(state.eConsentRawData, state, commit);
  }
}

export const filterByCountries = async ({commit, state}, {selectedCountries, filterAll}) => {
  const payload = {
    countries: {
      ...state.completionParticipant
    },
    countriesByActivities: {
      ...state.completion
    }
  };

  const filteredSites = utils.getAllSitesWhenFilteringCountry(payload, selectedCountries);
  const selectedSites = filterAll ? ["all"] : filteredSites;
  const eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(state.eConsentRawData, selectedCountries, filterAll ? state.allSitesList : selectedSites);

  commit (types.SET_COUNTRY_SELECTED, selectedCountries)
  commit (types.SET_SITES_SELECTED, selectedSites)
  commit (types.SET_ECONSET_DISPOSITION_DATA, eConsentDispositionData)
}

export const filterBySites = async ({commit, state}, {selectedSites, detailSite, filterAll}) => {
  const countrySelected = utils.getCountryWhenSiteFilterApply(selectedSites, state.countrySelected, detailSite, state.countryList);
  const eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(state.eConsentRawData, countrySelected, filterAll ? state.allSitesList : selectedSites);

  commit (types.SET_COUNTRY_SELECTED, countrySelected)
  commit (types.SET_SITES_SELECTED, selectedSites)
  commit (types.SET_ECONSET_DISPOSITION_DATA, eConsentDispositionData)
}
export const filterByParticipants = async ({commit, dispatch, state}, {$api, selectedParticipants}) => {
  commit(types.SET_IGNORE_CACHE, true)
  commit(types.SET_PARTICIPANTS_SELECTED, selectedParticipants)
  await Promise.all([
    dispatch("getCompletionData", { $api }),
    dispatch("getCompletionParticipantData", { $api }),
    dispatch("getVisConsentDispositionRawData", $api )
  ])
  commit(types.SET_IGNORE_CACHE, false)
  await setEConsentDispositionDataAndConsentBlocks(state.eConsentRawData, state, commit);
}

export const filterByDates = async ({commit, dispatch, state}, {$api, fromDate, toDate}) => {
  commit(types.SET_IGNORE_CACHE, true)
  commit(types.SET_FILTER_FROM_DATE, fromDate)
  commit(types.SET_FILTER_TO_DATE, toDate)
  await Promise.all([
    dispatch("getCompletionData", { $api, shouldChangeSelectedFilterOptions: false }),
    dispatch("getCompletionParticipantData", { $api, shouldChangeSelectedFilterOptions: false }),
    dispatch("getVisConsentDispositionRawData", $api)
  ])
  commit(types.SET_IGNORE_CACHE, false)
  await setEConsentDispositionDataAndConsentBlocks(state.eConsentRawData, state, commit);
}

// empty store
export const resetParticipantFocusCompletion = ({commit}) => {
  commit(types.SET_COMPLETION, {});
  commit(types.SET_FILTER_FROM_DATE, "")
  commit(types.SET_FILTER_TO_DATE, "")
  commit(types.SET_PARTICIPANTS_SELECTED, ["all"])
}

export const resetParticipantFocusCompletionParticipant = ({commit}) => {
  commit(types.SET_COMPLETION_PARTICIPANT, {});
}

export const resetEconsentDisposition = ({commit}) => {
  commit(types.SET_ECONSENT_RAW_DATA, {});
  commit(types.SET_ECONSET_DISPOSITION_DATA, {});
  commit(types.SET_CONSENT_BLOCKS, {});
}

export const saveParticipantsSelected = ({commit}, payload) => {
  commit(types.SET_PARTICIPANTS_SELECTED, payload)
}